export enum ActionType {
  WEB_REQUEST_ACTION_TYPE = "WEB_REQUEST_ACTION_TYPE",
  SCRIPT_ACTION_TYPE = "SCRIPT_ACTION_TYPE",
}
